import React, { Component } from 'react';

export default class RedirectToPlansPage extends Component {
  componentDidMount() {
    window.location.href = 'https://il.venn.city/plans';
  }
  render() {
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Views/OnboardingVirtualMembers/RedirectToPlansPage.js